import React from 'react';
import './edit-eval.styles.scss';

const EditEval = () => {
  return (
    <div className='edit-eval-container'>
      <div className='edit-eval-content g-card'>
        EditEval
      </div>
    </div>
  )
}

export default EditEval